export const editStageValidationRules = (values) => {
  const errors = {};

  if (!values.name || values.name.trim() === "") errors.name = "Name is required";
  else if (values.name && values.name.length < 3) errors.name = "Name must be at least 3 characters";
  else if (values.name && values.name.length > 255) errors.name = "Name must be at most 255 characters";
  if (values.description && values.description.length < 5) errors.description = "Description must be at least 5 characters";
  else if (values.description && values.description.length > 500)
    errors.description = "Description must be at most 500 characters";

  return errors;
};
